// TEMPORARY. The entire compatibility surface for the criterion -> label rename (OLIO-2695).
//
// The api still sends and accepts the label under its pre-rename key. OLIO-2994 flips the api to
// `label`, at which point `labelOf` starts resolving the new key with no change here; OLIO-2698
// then deletes this file and its call sites.
//
// Nothing else under src/ should name the old key. Read through `labelOf` and write through
// `legacyLabelPayload` so the flip is a one-file change.

/** Mix into a wire type so it accepts the pre-rename key alongside `label`. */
export type WithLegacyLabel = { criterion?: string };

/** The label off a wire object serialized on either side of the rename. */
export function labelOf(source: ({ label?: string } & WithLegacyLabel) | null | undefined): string {
  return source?.label || source?.criterion || '';
}

/**
 * The label as the api currently expects it on writes. Still the old key: web and api deploy
 * independently, so sending `label` before OLIO-2994 is out would be dropped by strong params
 * and fail the record's presence validation.
 */
export function legacyLabelPayload(label: string): WithLegacyLabel {
  return { criterion: label };
}
